module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-76x76-fe92a6db3f4ef916e4a436382f3c2191.png";